import { HttpClient } from '../httpClient';
import EntryTypesResponse from '../responses/entryTypesResponse';

const httpClient = new HttpClient();

export const getEntryTypesForTaskType = async () => {
  return httpClient.get<EntryTypesResponse>({
    url: '/v1/entrytypes?taskTypeUsed=true',
    requiresToken: true,
  });
};


